import React, { ReactElement, useEffect, useState } from "react";
import {
  ElaborationStatus,
  ElaborationStatusItem,
  selectElaborationStatusList,
} from "../../redux/feature/object/remote-elaborations-slice";
import { useAppSelector } from "../../redux/hooks/hooks";

export interface GenericElaborationSelectorProps {
  findFunction: (item: FindItem) => boolean;
  children: (elaborationItem?: ElaborationStatusItem) => ReactElement;
}

export type FindItem = ElaborationStatusItem & { elaboration: Omit<ElaborationStatus, "items"> };

export const useFilteredElaborations = (props: Omit<GenericElaborationSelectorProps, "children">) => {
  const elaborations = useAppSelector(selectElaborationStatusList);

  const [elaborationItem, setElaborationItem] = useState<ElaborationStatusItem | undefined>();

  useEffect(() => {
    if (elaborations) {
      const elaborationItems: FindItem[] = elaborations
        .flatMap((e) => e.items.map((i) => ({ ...i, elaboration: e })))
        .sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime());

      const elaborationItem = elaborationItems.find(props.findFunction);

      setElaborationItem(elaborationItem);
    }
  }, [elaborations, props.findFunction]);

  return elaborationItem;
};
export const GenericElaborationSelector: React.FunctionComponent<GenericElaborationSelectorProps> = (props) => {
  const elaborationItem = useFilteredElaborations(props);

  return props.children(elaborationItem);
};
